import React from 'react';
import './HeroBanner.css';

const HeroBanner = ({ heading, subheading, actionText, backgroundImage, fullAddress, phone }) => (
  <div className="heroBanner" style={{ backgroundImage: `url(${backgroundImage})` }}>
    { heading && subheading && actionText &&
    <div className="heroContent">
      <h1 className="heroHeading">{heading}</h1>
      <p className="heroSubheading">{subheading}</p>
      <a href={`tel:+${phone}`}>
          <button className="heroAction">{actionText}</button>
      </a>
    </div>
    }
  </div>
);

export default HeroBanner;
